import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { ActivityTimeline } from "@/features/activity/components/activity-timeline"
import { IndividualOnboarding } from "@/features/individuals/components/individual-onboarding"
import { IndividualRequestActions } from "@/features/individuals/components/individual-request-actions"
import { OpenIssues } from "@/features/issues/components/open-issues"
import { PlanComingUp } from "@/features/plan/components/plan-coming-up"
import { IndividualRegisterWarnings } from "@/features/register/components/register-warnings"
import { SubjectReviews } from "@/features/reviews/components/subject-reviews"
import { SendReviewButton } from "@/features/reviews/components/send-review-button"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/"
)({
  component: IndividualOverviewPage,
})

function IndividualOverviewPage() {
  const { individualId } = Route.useParams()

  return (
    <>
      <PageHeader
        title="Overview"
        actions={
          <>
            <IndividualRequestActions individualId={individualId} />
            <SendReviewButton individualId={individualId} />
          </>
        }
      />
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-10">
        <IndividualRegisterWarnings individualId={individualId} />
        <IndividualOnboarding individualId={individualId} />
        <SubjectReviews filters={{ individual_id: individualId }} />
        <OpenIssues subject={{ type: "individual", id: individualId }} />
        <PlanComingUp subject={{ type: "individual", id: individualId }} />
        <ActivityTimeline subject={{ type: "individual", id: individualId }} />
      </div>
    </>
  )
}
